export function Spinner({ className = '', size }: { className?: string; size?: number }) {
  const style = size ? { width: `${size}px`, height: `${size}px` } : undefined;
  return (
    <div
      style={style}
      className={`h-5 w-5 animate-spin rounded-full border-2 border-slate-600 border-t-accent ${className}`}
      role="status"
      aria-label="Загрузка"
    />
  );
}
